import { USER_STATUS_LOGGED_IN, USER_STATUS_LOGGED_OUT } from "common/session";
import { useEffect, useState } from "react";
const { useAuth } = require("common/auth");
const { useNavigate } = require("react-router");

export function RequireAuth({ children, userGroup }) {
    const [isAuthorized, setIsAuthorized] = useState(null);
    const { getAuthenticationStatus, getProfile, authenticationStatus } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        async function getAuth() {
            const auth = await getAuthenticationStatus();
            let authorized = auth === USER_STATUS_LOGGED_IN;

            if (userGroup) {
                const { userGroups } = getProfile();
                authorized = authorized && Array.isArray(userGroups) && userGroups.indexOf(userGroup) >= 0;
            }

            setIsAuthorized(authorized);
            if (auth === USER_STATUS_LOGGED_OUT) {
                navigate("/profile/login");
            }
        }
        getAuth();
        // Re-evaluate only when auth status or the required group changes,
        // instead of on every render.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authenticationStatus, userGroup]);

    return isAuthorized === true
        ? children
        : "";
}
